var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-wrapper"},[_c('SuccessForm',{attrs:{"successForm":_vm.successForm},on:{"primaryEvent":_vm.gotoDashboard}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }